import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintenanceManEditDeviceBaseInfo(data) {
    return maintainRequest.post("/device/maintenanceMan/chargingPile/editDeviceBaseInfo", data)
}
